// kagitEvrak.js — KÂĞIT OFP EVRAKI: DENETİM, YÜKLEME, KALDIRMA — TEK KAYNAK (2 Eki 2026)
//
// 🔑 Serkan (2 Eki 2026): ofis kâğıt uçuşu EDIT'te girerken uçaktan gelen evrakı (ofiste taranmış PDF) yükler, SAVE
//    eder; arşivde yan panelde VIEW + DOWNLOAD (*"aksi halde ne mantığı var doküman yüklemenin"*). Kararlar: yalnız PDF ·
//    dosya başına en fazla 20 MB · birden çok · zorunlu değil · kaldırılan evrak TAMAMEN silinir (iz satırı kalır) ·
//    yönetim YALNIZ DUTY HISTORY → EDIT.
// Veritabanı aynı kuralları ayrıca uygular (20261002c: CHECK + RLS, yazma `ftl_is_editor`): ekran yalnız ÖNCE söyler.
// Yazmalar DÖNEN SATIRLA doğrulanır — RLS reddi hata değil 0 satır döner (İlke 2).
import { supabase } from '../supabaseClient';

export const KAGIT_EVRAK_BOLUMU = 'PAPER_OFP';
export const KAGIT_EVRAK_KOVASI = 'efb-documents';
/** 20 MB — Finder'ın gösterdiği "MB" ile aynı ölçü (1 MB = 1.000.000 bayt); veritabanı CHECK'iyle AYNI sayı. */
export const KAGIT_EVRAK_AZAMI = 20000000;

/** "1.8 MB" — Finder ölçüsü. */
export const mbYaz = (bayt) => `${(Number(bayt || 0) / 1e6).toFixed(1)} MB`;

/** Seçilen dosya yüklenebilir mi? `null` = evet; değilse ADIYLA sebep. */
export function kagitEvrakDenetle(dosya) {
  const ad = dosya?.name || '?';
  const pdfAdi = /\.pdf$/i.test(ad);
  const pdfTuru = !dosya?.type || dosya.type === 'application/pdf';
  if (!pdfAdi || !pdfTuru) return `${ad}: only PDF files can be attached`;
  if (!dosya.size) return `${ad}: the file is empty`;
  if (dosya.size > KAGIT_EVRAK_AZAMI) return `${ad}: ${mbYaz(dosya.size)} — the limit is 20 MB per PDF`;
  return null;
}

/** Klasördeki yol: `paper-ofp/<kâğıt uçuş anahtarı>/<kimlik>.pdf` — kural bu yolla şirketi bulur (20261002c). */
export const kagitEvrakYolu = (anahtar, id) => `paper-ofp/${anahtar}/${id}.pdf`;

/** Kâğıt uçuşun evrakı (en eski üstte). */
export async function kagitEvraklari(anahtar) {
  if (!anahtar) return { data: [], error: null };
  return supabase.from('efb_documents')
    .select('id,file_name,file_path,file_size,uploaded_at,uploaded_by')
    .eq('section', KAGIT_EVRAK_BOLUMU).eq('assignment_id', anahtar)
    .order('uploaded_at', { ascending: true });
}

/** Verilen kâğıt uçuş anahtarlarından EVRAKI OLANLAR — NO DOCS rozeti (DUTY HISTORY, 5 Eki 2026). 200'lük dilimler.
 *  Okunamazsa `anahtarlar: null` — rozet çizilmez (bilinmiyor ≠ yok). @returns {Promise<{ anahtarlar: Set|null, hata? }>} */
export async function evrakliKagitAnahtarlari(anahtarlar) {
  const liste = [...new Set((anahtarlar || []).filter(Boolean))];
  const out = new Set();
  for (let i = 0; i < liste.length; i += 200) {
    const { data, error } = await supabase.from('efb_documents').select('assignment_id')
      .eq('section', KAGIT_EVRAK_BOLUMU).in('assignment_id', liste.slice(i, i + 200));
    if (error) return { anahtarlar: null, hata: error.message };
    (data || []).forEach(x => out.add(x.assignment_id));
  }
  return { anahtarlar: out };
}

/** Önce dosya, sonra satır. Satır yazılamazsa dosya geri alınır — sahipsiz dosya kalmasın.
 *  @returns {Promise<{ satir?: object, hata?: string }>} */
export async function kagitEvrakEkle({ anahtar, customerId, dosya, yukleyen, id }) {
  const path = kagitEvrakYolu(anahtar, id);
  const kova = supabase.storage.from(KAGIT_EVRAK_KOVASI);
  const { error: yErr } = await kova.upload(path, dosya, { contentType: 'application/pdf', upsert: false });
  if (yErr) return { hata: `${dosya.name}: upload failed — ${yErr.message}` };
  const { data, error } = await supabase.from('efb_documents').insert({
    section: KAGIT_EVRAK_BOLUMU, file_name: dosya.name, file_path: path, file_size: dosya.size,
    mime_type: 'application/pdf', uploaded_by: yukleyen ?? null, uploaded_at: new Date().toISOString(),
    status: 'CURRENT', assignment_id: anahtar, customer_id: customerId,
  }).select('id');
  if (error || data?.length !== 1) {
    await kova.remove([path]);
    return { hata: `${dosya.name}: not recorded — ${error?.message || 'no row returned (permission?)'}` };
  }
  return { satir: { id: data[0].id, file_name: dosya.name, file_path: path, file_size: dosya.size } };
}

/** Önce satır, sonra dosya: satır kalıp dosya giderse arşiv olmayan bir dosyayı gösterirdi; tersi (sahipsiz dosya)
 *  görünmez ve zararsızdır. @returns {Promise<{ hata?: string }>} */
export async function kagitEvrakKaldir(satir) {
  const { data, error } = await supabase.from('efb_documents').delete().eq('id', satir.id).select('id');
  if (error || data?.length !== 1) {
    return { hata: `${satir.file_name}: not removed — ${error?.message || 'no row returned (permission?)'}` };
  }
  const { data: giden, error: sErr } = await supabase.storage.from(KAGIT_EVRAK_KOVASI).remove([satir.file_path]);
  if (sErr || !giden?.length) {
    return { hata: `${satir.file_name}: record removed, but the file stayed in storage — ${sErr?.message || 'not deleted'}` };
  }
  return {};
}
